"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7801],{

/***/ 39679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* reexport */ Money; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/legacy/ShopProvider/context.ts
var context = __webpack_require__(61888);
;// CONCATENATED MODULE: ./src/components/containers/Money/Money.tsx






var Money = function(_param) {
    var money = _param.money, defaultValue = _param.defaultValue, _showDecimals = _param.showDecimals, showDecimals = _showDecimals === void 0 ? true : _showDecimals, props = (0,_object_without_properties/* default */.Z)(_param, [
        "money",
        "defaultValue",
        "showDecimals"
    ]);
    if (!money) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: defaultValue
        }));
    }
    var ref = (0,react.useContext)(context/* ShopContext */.I), defaultCountry = ref.defaultCountry, currency = ref.currency;
    var amount = money.amount;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: money.currency ? amount.toLocaleString("en-".concat((defaultCountry === null || defaultCountry === void 0 ? void 0 : defaultCountry.code) || "AU"), {
            style: "currency",
            currency: currency,
            maximumFractionDigits: showDecimals ? 2 : 0,
            minimumFractionDigits: showDecimals ? 2 : 0
        }) : amount.toString()
    }));
};
Money.displayName = "Money";
/* harmony default export */ var Money_Money = ((/* unused pure expression or super */ null && (Money)));

;// CONCATENATED MODULE: ./src/components/containers/Money/index.ts



/***/ }),

/***/ 61888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ ShopContext; },
/* harmony export */   "O": function() { return /* binding */ defaultContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var defaultCountry = {
    __typename: "CountryDisplay",
    code: "AU",
    country: "Australia"
};
var defaultContext = {
    __typename: "Shop",
    countries: [],
    defaultCountry: defaultCountry,
    displayGrossPrices: true,
    saleBannerMessage: null,
    name: "The Volte",
    marketplace: true,
    language: "en-AU",
    domain: {
        url: "https://thevolte.com",
        host: "thevolte.com",
        __typename: "Domain"
    },
    currency: "AU",
    demonym: "Australian",
    operatingHours: [],
    samedayOrNextdayPickupDistance: "25"
};
var ShopContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(defaultContext);
ShopContext.displayName = "ShopContext";


/***/ }),

/***/ 32236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dz": function() { return /* binding */ convertSortByFromString; },
  "rh": function() { return /* binding */ convertToAttributeScalar; },
  "qk": function() { return /* binding */ getLinkMenuItem; },
  "TD": function() { return /* binding */ snakeToCamel; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
;// CONCATENATED MODULE: ./src/types/global.ts
/* tslint:disable */ /* eslint-disable */ // @generated
// This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
/**
 * An enumeration.
 */ var CountryCode;
(function(CountryCode) {
    CountryCode["AD"] = "AD";
    CountryCode["AE"] = "AE";
    CountryCode["AF"] = "AF";
    CountryCode["AG"] = "AG";
    CountryCode["AI"] = "AI";
    CountryCode["AL"] = "AL";
    CountryCode["AM"] = "AM";
    CountryCode["AO"] = "AO";
    CountryCode["AQ"] = "AQ";
    CountryCode["AR"] = "AR";
    CountryCode["AS"] = "AS";
    CountryCode["AT"] = "AT";
    CountryCode["AU"] = "AU";
    CountryCode["AW"] = "AW";
    CountryCode["AX"] = "AX";
    CountryCode["AZ"] = "AZ";
    CountryCode["BA"] = "BA";
    CountryCode["BB"] = "BB";
    CountryCode["BD"] = "BD";
    CountryCode["BE"] = "BE";
    CountryCode["BF"] = "BF";
    CountryCode["BG"] = "BG";
    CountryCode["BH"] = "BH";
    CountryCode["BI"] = "BI";
    CountryCode["BJ"] = "BJ";
    CountryCode["BL"] = "BL";
    CountryCode["BM"] = "BM";
    CountryCode["BN"] = "BN";
    CountryCode["BO"] = "BO";
    CountryCode["BQ"] = "BQ";
    CountryCode["BR"] = "BR";
    CountryCode["BS"] = "BS";
    CountryCode["BT"] = "BT";
    CountryCode["BV"] = "BV";
    CountryCode["BW"] = "BW";
    CountryCode["BY"] = "BY";
    CountryCode["BZ"] = "BZ";
    CountryCode["CA"] = "CA";
    CountryCode["CC"] = "CC";
    CountryCode["CD"] = "CD";
    CountryCode["CF"] = "CF";
    CountryCode["CG"] = "CG";
    CountryCode["CH"] = "CH";
    CountryCode["CI"] = "CI";
    CountryCode["CK"] = "CK";
    CountryCode["CL"] = "CL";
    CountryCode["CM"] = "CM";
    CountryCode["CN"] = "CN";
    CountryCode["CO"] = "CO";
    CountryCode["CR"] = "CR";
    CountryCode["CU"] = "CU";
    CountryCode["CV"] = "CV";
    CountryCode["CW"] = "CW";
    CountryCode["CX"] = "CX";
    CountryCode["CY"] = "CY";
    CountryCode["CZ"] = "CZ";
    CountryCode["DE"] = "DE";
    CountryCode["DJ"] = "DJ";
    CountryCode["DK"] = "DK";
    CountryCode["DM"] = "DM";
    CountryCode["DO"] = "DO";
    CountryCode["DZ"] = "DZ";
    CountryCode["EC"] = "EC";
    CountryCode["EE"] = "EE";
    CountryCode["EG"] = "EG";
    CountryCode["EH"] = "EH";
    CountryCode["ER"] = "ER";
    CountryCode["ES"] = "ES";
    CountryCode["ET"] = "ET";
    CountryCode["EU"] = "EU";
    CountryCode["FI"] = "FI";
    CountryCode["FJ"] = "FJ";
    CountryCode["FK"] = "FK";
    CountryCode["FM"] = "FM";
    CountryCode["FO"] = "FO";
    CountryCode["FR"] = "FR";
    CountryCode["GA"] = "GA";
    CountryCode["GB"] = "GB";
    CountryCode["GD"] = "GD";
    CountryCode["GE"] = "GE";
    CountryCode["GF"] = "GF";
    CountryCode["GG"] = "GG";
    CountryCode["GH"] = "GH";
    CountryCode["GI"] = "GI";
    CountryCode["GL"] = "GL";
    CountryCode["GM"] = "GM";
    CountryCode["GN"] = "GN";
    CountryCode["GP"] = "GP";
    CountryCode["GQ"] = "GQ";
    CountryCode["GR"] = "GR";
    CountryCode["GS"] = "GS";
    CountryCode["GT"] = "GT";
    CountryCode["GU"] = "GU";
    CountryCode["GW"] = "GW";
    CountryCode["GY"] = "GY";
    CountryCode["HK"] = "HK";
    CountryCode["HM"] = "HM";
    CountryCode["HN"] = "HN";
    CountryCode["HR"] = "HR";
    CountryCode["HT"] = "HT";
    CountryCode["HU"] = "HU";
    CountryCode["ID"] = "ID";
    CountryCode["IE"] = "IE";
    CountryCode["IL"] = "IL";
    CountryCode["IM"] = "IM";
    CountryCode["IN"] = "IN";
    CountryCode["IO"] = "IO";
    CountryCode["IQ"] = "IQ";
    CountryCode["IR"] = "IR";
    CountryCode["IS"] = "IS";
    CountryCode["IT"] = "IT";
    CountryCode["JE"] = "JE";
    CountryCode["JM"] = "JM";
    CountryCode["JO"] = "JO";
    CountryCode["JP"] = "JP";
    CountryCode["KE"] = "KE";
    CountryCode["KG"] = "KG";
    CountryCode["KH"] = "KH";
    CountryCode["KI"] = "KI";
    CountryCode["KM"] = "KM";
    CountryCode["KN"] = "KN";
    CountryCode["KP"] = "KP";
    CountryCode["KR"] = "KR";
    CountryCode["KW"] = "KW";
    CountryCode["KY"] = "KY";
    CountryCode["KZ"] = "KZ";
    CountryCode["LA"] = "LA";
    CountryCode["LB"] = "LB";
    CountryCode["LC"] = "LC";
    CountryCode["LI"] = "LI";
    CountryCode["LK"] = "LK";
    CountryCode["LR"] = "LR";
    CountryCode["LS"] = "LS";
    CountryCode["LT"] = "LT";
    CountryCode["LU"] = "LU";
    CountryCode["LV"] = "LV";
    CountryCode["LY"] = "LY";
    CountryCode["MA"] = "MA";
    CountryCode["MC"] = "MC";
    CountryCode["MD"] = "MD";
    CountryCode["ME"] = "ME";
    CountryCode["MF"] = "MF";
    CountryCode["MG"] = "MG";
    CountryCode["MH"] = "MH";
    CountryCode["MK"] = "MK";
    CountryCode["ML"] = "ML";
    CountryCode["MM"] = "MM";
    CountryCode["MN"] = "MN";
    CountryCode["MO"] = "MO";
    CountryCode["MP"] = "MP";
    CountryCode["MQ"] = "MQ";
    CountryCode["MR"] = "MR";
    CountryCode["MS"] = "MS";
    CountryCode["MT"] = "MT";
    CountryCode["MU"] = "MU";
    CountryCode["MV"] = "MV";
    CountryCode["MW"] = "MW";
    CountryCode["MX"] = "MX";
    CountryCode["MY"] = "MY";
    CountryCode["MZ"] = "MZ";
    CountryCode["NA"] = "NA";
    CountryCode["NC"] = "NC";
    CountryCode["NE"] = "NE";
    CountryCode["NF"] = "NF";
    CountryCode["NG"] = "NG";
    CountryCode["NI"] = "NI";
    CountryCode["NL"] = "NL";
    CountryCode["NO"] = "NO";
    CountryCode["NP"] = "NP";
    CountryCode["NR"] = "NR";
    CountryCode["NU"] = "NU";
    CountryCode["NZ"] = "NZ";
    CountryCode["OM"] = "OM";
    CountryCode["PA"] = "PA";
    CountryCode["PE"] = "PE";
    CountryCode["PF"] = "PF";
    CountryCode["PG"] = "PG";
    CountryCode["PH"] = "PH";
    CountryCode["PK"] = "PK";
    CountryCode["PL"] = "PL";
    CountryCode["PM"] = "PM";
    CountryCode["PN"] = "PN";
    CountryCode["PR"] = "PR";
    CountryCode["PS"] = "PS";
    CountryCode["PT"] = "PT";
    CountryCode["PW"] = "PW";
    CountryCode["PY"] = "PY";
    CountryCode["QA"] = "QA";
    CountryCode["RE"] = "RE";
    CountryCode["RO"] = "RO";
    CountryCode["RS"] = "RS";
    CountryCode["RU"] = "RU";
    CountryCode["RW"] = "RW";
    CountryCode["SA"] = "SA";
    CountryCode["SB"] = "SB";
    CountryCode["SC"] = "SC";
    CountryCode["SD"] = "SD";
    CountryCode["SE"] = "SE";
    CountryCode["SG"] = "SG";
    CountryCode["SH"] = "SH";
    CountryCode["SI"] = "SI";
    CountryCode["SJ"] = "SJ";
    CountryCode["SK"] = "SK";
    CountryCode["SL"] = "SL";
    CountryCode["SM"] = "SM";
    CountryCode["SN"] = "SN";
    CountryCode["SO"] = "SO";
    CountryCode["SR"] = "SR";
    CountryCode["SS"] = "SS";
    CountryCode["ST"] = "ST";
    CountryCode["SV"] = "SV";
    CountryCode["SX"] = "SX";
    CountryCode["SY"] = "SY";
    CountryCode["SZ"] = "SZ";
    CountryCode["TC"] = "TC";
    CountryCode["TD"] = "TD";
    CountryCode["TF"] = "TF";
    CountryCode["TG"] = "TG";
    CountryCode["TH"] = "TH";
    CountryCode["TJ"] = "TJ";
    CountryCode["TK"] = "TK";
    CountryCode["TL"] = "TL";
    CountryCode["TM"] = "TM";
    CountryCode["TN"] = "TN";
    CountryCode["TO"] = "TO";
    CountryCode["TR"] = "TR";
    CountryCode["TT"] = "TT";
    CountryCode["TV"] = "TV";
    CountryCode["TW"] = "TW";
    CountryCode["TZ"] = "TZ";
    CountryCode["UA"] = "UA";
    CountryCode["UG"] = "UG";
    CountryCode["UM"] = "UM";
    CountryCode["US"] = "US";
    CountryCode["UY"] = "UY";
    CountryCode["UZ"] = "UZ";
    CountryCode["VA"] = "VA";
    CountryCode["VC"] = "VC";
    CountryCode["VE"] = "VE";
    CountryCode["VG"] = "VG";
    CountryCode["VI"] = "VI";
    CountryCode["VN"] = "VN";
    CountryCode["VU"] = "VU";
    CountryCode["WF"] = "WF";
    CountryCode["WS"] = "WS";
    CountryCode["YE"] = "YE";
    CountryCode["YT"] = "YT";
    CountryCode["ZA"] = "ZA";
    CountryCode["ZM"] = "ZM";
    CountryCode["ZW"] = "ZW";
})(CountryCode || (CountryCode = {}));
var OrderDirection;
(function(OrderDirection) {
    OrderDirection["ASC"] = "ASC";
    OrderDirection["DESC"] = "DESC";
})(OrderDirection || (OrderDirection = {}));
var ProductOrderField;
(function(ProductOrderField) {
    ProductOrderField["COLLECTION"] = "COLLECTION";
    ProductOrderField["CREATED_AT"] = "CREATED_AT";
    ProductOrderField["DATE"] = "DATE";
    ProductOrderField["MINIMAL_PRICE"] = "MINIMAL_PRICE";
    ProductOrderField["PRICE"] = "PRICE";
    ProductOrderField["PUBLICATION_DATE"] = "PUBLICATION_DATE";
    ProductOrderField["PUBLISHED"] = "PUBLISHED";
    ProductOrderField["RANK"] = "RANK";
    ProductOrderField["RATING"] = "RATING";
    ProductOrderField["TYPE"] = "TYPE";
})(ProductOrderField || (ProductOrderField = {}));
 //==============================================================
 // END Enums and Input Objects
 //==============================================================

;// CONCATENATED MODULE: ./src/core/utils.ts




function convertToAttributeScalar(attributes) {
    var attrs = {};
    Object.entries(attributes).forEach(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        if (!attrs[key]) {
            attrs[key] = [];
        }
        attrs[key].push(value);
    });
    return Object.entries(attrs).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        return value.map(function(attribute) {
            return {
                slug: key,
                values: attribute
            };
        });
    }).reduce(function(prev, curr) {
        return (0,_to_consumable_array/* default */.Z)(prev).concat((0,_to_consumable_array/* default */.Z)(curr));
    }, []);
}
var convertSortByFromString = function(sortBy) {
    var channel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : constants/* channelSlug */.m_;
    if (!sortBy) {
        return null;
    }
    var direction = sortBy.startsWith("-") ? OrderDirection.DESC : OrderDirection.ASC;
    var field;
    switch(sortBy.replace(/^-/, "")){
        case "price":
            field = ProductOrderField.PRICE;
            break;
        case "created_at":
            field = ProductOrderField.CREATED_AT;
            break;
        default:
            return null;
    }
    return {
        field: field,
        direction: direction,
        channel: channel
    };
};
function snakeToCamel(obj) {
    if (obj === null || typeof obj !== "object") {
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map(function(item) {
            return snakeToCamel(item);
        });
    }
    return Object.fromEntries(Object.entries(obj).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        return [
            key.replace(/_([a-z])/g, function(_, letter) {
                return letter.toUpperCase();
            }),
            snakeToCamel(value), 
        ];
    }));
}
var getLinkMenuItem = function(menuItem) {
    if (!menuItem) {
        return "";
    }
    var url = menuItem.url;
    if (url) {
        return url;
    }
    return "";
};


/***/ }),

/***/ 67083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useLogin; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70655);
/* harmony import */ var _the_volte_svc_core_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44859);
/* harmony import */ var _the_volte_svc_core_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_the_volte_svc_core_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _app_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42660);




function useLogin() {
    var externalLogin = (0,_the_volte_svc_core_sdk__WEBPACK_IMPORTED_MODULE_0__.useAuth)().externalLogin;
    var externalAuthPlugin = "keycloak.openidconnect";
    var getAuthUrl = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(redirectQuery, redirectPath) {
            var queryString, redirectUrl, redirectUri, payload, ref, _data, authenticationData, authorizationUrl;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!_app_constants__WEBPACK_IMPORTED_MODULE_1__/* .ssrMode */ .$m) return [
                            3,
                            2
                        ];
                        queryString = new URLSearchParams(redirectQuery);
                        redirectUrl = redirectPath ? "".concat(_app_constants__WEBPACK_IMPORTED_MODULE_1__/* .siteUrl */ .or).concat(redirectPath) : window.location.href;
                        redirectUri = redirectQuery ? "".concat(redirectUrl, "?").concat(queryString.toString()) : redirectUrl;
                        payload = {
                            pluginId: externalAuthPlugin,
                            input: JSON.stringify({
                                redirectUri: redirectUri
                            })
                        };
                        return [
                            4,
                            externalLogin(payload)
                        ];
                    case 1:
                        ref = _state.sent(), _data = ref.data, authenticationData = _data.externalAuthenticationUrl.authenticationData;
                        authorizationUrl = JSON.parse(authenticationData).authorizationUrl;
                        return [
                            2,
                            authorizationUrl
                        ];
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function getAuthUrl(redirectQuery, redirectPath) {
            return _ref.apply(this, arguments);
        };
    }();
    var login = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(redirectQuery, redirectPath) {
            var authorizationUrl;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!_app_constants__WEBPACK_IMPORTED_MODULE_1__/* .ssrMode */ .$m) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            getAuthUrl(redirectQuery, redirectPath)
                        ];
                    case 1:
                        authorizationUrl = _state.sent();
                        window.location.href = authorizationUrl;
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function login(redirectQuery, redirectPath) {
            return _ref.apply(this, arguments);
        };
    }();
    var register = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(redirectQuery, redirectPath) {
            var authorizationUrl;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!_app_constants__WEBPACK_IMPORTED_MODULE_1__/* .ssrMode */ .$m) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            getAuthUrl(redirectQuery, redirectPath)
                        ];
                    case 1:
                        authorizationUrl = _state.sent();
                        window.location.href = authorizationUrl.replace("auth?", "registrations?");
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function register(redirectQuery, redirectPath) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        externalAuthPlugin: externalAuthPlugin,
        login: login,
        register: register
    };
}


/***/ }),

/***/ 4032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ paths; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42660);

var baseUrl = "/";
var slugUrl = ":slug";
var accountBaseUrl = "".concat(baseUrl, "account/");
var checkoutBaseUrl = "".concat(baseUrl, "checkout/");
var pageBaseUrl = "".concat(baseUrl, "page/");
var categoryBaseUrl = "".concat(baseUrl, "category/");
var collectionBaseUrl = "".concat(baseUrl, "collection/");
var paths = {
    notFound: "".concat(baseUrl, "404"),
    accountConfirm: "".concat(baseUrl, "account-confirm"),
    cart: "".concat(baseUrl, "cart"),
    categoryBase: "".concat(categoryBaseUrl),
    category: "".concat(categoryBaseUrl).concat(slugUrl),
    dresses: "".concat(baseUrl).concat(slugUrl),
    collectionBase: "".concat(collectionBaseUrl),
    collection: "".concat(collectionBaseUrl).concat(slugUrl),
    guestOrderDetail: "".concat(baseUrl, "order-history/:token"),
    home: baseUrl,
    login: "".concat(baseUrl, "login"),
    processingpayment: "".concat(baseUrl, "processing-payment"),
    orderFinalized: "".concat(baseUrl, "order-finalized"),
    pageBase: "".concat(pageBaseUrl),
    page: "".concat(pageBaseUrl, ":slug"),
    passwordReset: "".concat(baseUrl, "reset-password"),
    product: "".concat(baseUrl, "item/").concat(slugUrl),
    search: "".concat(baseUrl, "search"),
    defaultCategory: "".concat(baseUrl, "dresses"),
    orderRating: "".concat(baseUrl, "review/rating"),
    /**
   * Checkout
   */ checkout: checkoutBaseUrl,
    checkoutAddress: "".concat(checkoutBaseUrl, "address"),
    checkoutPayment: "".concat(checkoutBaseUrl, "payment"),
    checkoutPaymentConfirm: "".concat(checkoutBaseUrl, "payment-confirm"),
    checkoutReview: "".concat(checkoutBaseUrl, "review"),
    checkoutShipping: "".concat(checkoutBaseUrl, "shipping"),
    /**
   * Account section
   */ account: accountBaseUrl,
    accountAddressBook: "".concat(accountBaseUrl, "address-book"),
    wishlist: "".concat(accountBaseUrl, "wishlist"),
    // FIXME: User order should be accessible via order id
    accountOrderDetail: "".concat(accountBaseUrl, "order-history/:token"),
    accountOrderHistory: "".concat(accountBaseUrl, "order-history"),
    accountOrderOverview: "".concat(accountBaseUrl, "order-history/:token/overview"),
    dashboard: "".concat(_constants__WEBPACK_IMPORTED_MODULE_0__/* .siteUrl */ .or, "/dashboard/"),
    accountMessages: "".concat(accountBaseUrl, "messages"),
    accountLending: "".concat(_constants__WEBPACK_IMPORTED_MODULE_0__/* .siteUrl */ .or, "/dashboard/"),
    accountLendingProducts: "".concat(_constants__WEBPACK_IMPORTED_MODULE_0__/* .siteUrl */ .or, "/dashboard/products"),
    /**
   * Designers
   */ designers: "".concat(baseUrl, "designers"),
    designer: "".concat(baseUrl, "designers/").concat(slugUrl),
    /**
   * Promo pages
   */ partnerPromo: "".concat(baseUrl, "wear-the-dress-share-the-dress"),
    /**
   * Partner portal
   */ partners: "".concat(_constants__WEBPACK_IMPORTED_MODULE_0__/* .siteUrl */ .or, "/partners/"),
    /**
   * Enquire
   */ enquire: "/item/:slug/enquire/"
};


/***/ })

}]);